import "./Skeleton.scss";

export const Skeleton = ({ children }) => {
	return <div className="skeleton-wrapper">{children}</div>;
};

Skeleton.Avatar = function Avatar({ size = 50 }) {
	return <div className="skeleton-avatar" style={{ width: size, height: size }} />;
};

Skeleton.Line = function Line({ width = "100%", height = "1rem" }) {
	return <div className="skeleton-line" style={{ width, height }} />;
};

Skeleton.Block = function Block({ width = "100%", height = "100px" }) {
	return <div className="skeleton-block" style={{ width, height }} />;
};

Skeleton.Text = function Block({ width = "100px", height = "22px" }) {
	return <div className="skeleton-text" style={{ width, height }} />;
};
